import React, { useState, useEffect, useCallback } from "react"
import { getJSON } from "../../../shared_component/utils/fetch"
import sortBy from "lodash/sortBy"
import { addVehicleYearRange } from "../../../v1/helpers/vehicleHelpers"
import uniqBy from "lodash/uniqBy"
import { connect } from "react-redux"
import { addNewVehicle } from "../../../v1/actions/user"
import { Dropdown, Button, Loader, Card, Image } from "semantic-ui-react"
import { withTranslation } from "react-i18next"
import Notifications from "../../../v1/components/Notifications"
import InfoIcon from "../../../images/info-Icon.svg"
import store from "../../../shared_component/utils/configureStore"
import { routerPaths } from "../../../v1/constants/paths"

const BY_YEAR_URL = "/api/v4/vehicles/years/:year/makes"
const BY_YEAR_AND_MAKE_URL = "/api/v4/vehicles/years/:year/makes/:make"

const CompareVehicle = (props) => {
  const { user, t, addNewVehicle, history } = props
  const [years] = useState(
    addVehicleYearRange().map((n) => ({
      key: String(n),
      text: String(n),
      value: String(n)
    }))
  )
  const [makes, setMakes] = useState([])
  const [models, setModels] = useState([])
  const [year, setYear] = useState("")
  const [make, setMake] = useState("")
  const [model, setModel] = useState("")
  const [loadingMakes, setLoadingMakes] = useState(false)
  const [loadingModels, setLoadingModels] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const fetchMakes = useCallback(async () => {
    if (!year) return
    setLoadingMakes(true)
    let response = await getJSON(BY_YEAR_URL.replace(":year", year))
    setLoadingMakes(false)
    if (response.error) {
      store.dispatch(
        Notifications.error({
          title: t("errorLbl"),
          message: response.error.toString(),
          position: "tr",
          autoDismiss: 5,
          action: { label: "Dismiss" }
        })
      )
    } else if (response.result) {
      let makesArr = response.result.map(({ make_id, make }) => {
        return { key: String(make_id), text: make, value: String(make) }
      })
      makesArr = sortBy(makesArr, ({ text }) => text.toLowerCase())
      setMakes(makesArr)
      setModels([])
      setMake("")
      setModel("")
    }
  }, [year, t])

  const fetchModels = useCallback(async () => {
    if (!year || !make) return
    let makeObj = makes.find(({ value }) => value === make) || {}
    let make_id = makeObj.key
    if (!make_id) return
    setLoadingModels(true)
    let response = await getJSON(
      BY_YEAR_AND_MAKE_URL.replace(":year", year).replace(":make", make_id)
    )
    setLoadingModels(false)
    if (response.error) {
      store.dispatch(
        Notifications.error({
          title: t("errorLbl"),
          message: response.error.toString(),
          position: "tr",
          autoDismiss: 5,
          action: { label: "Dismiss" }
        })
      )
    } else if (response.result) {
      let modelsArr = response.result.map((vehicle) => ({
        key: String(vehicle.model_id),
        text: vehicle.model,
        value: String(vehicle.model)
      }))
      modelsArr = uniqBy(modelsArr, "key")
      modelsArr = sortBy(modelsArr, ({ text }) => text.toLowerCase())
      setModels(modelsArr)
      setModel("")
    }
  }, [year, make, makes, t])

  const onYearChange = (value) => {
    setYear(value)
  }
  const onMakeChange = (value) => {
    setMake(value)
  }
  const onModelChange = (value) => {
    setModel(value)
  }

  const onClickNext = async () => {
    setIsLoading(true)
    let data = {
      year,
      make
    }
    let makeObj = makes.find(({ value }) => value === make) || {}
    let modelObj = models.find(({ value }) => value === model) || {}
    data.make_id = makeObj.key
    data.model_id = modelObj.key
    data.model = modelObj.text
    let success = false
    try {
      success = await addNewVehicle(data, true)
      if (success) {
        history.push({
          pathname: routerPaths.selectService
        })
      } else {
        store.dispatch(
          Notifications.error({
            title: t("errorLbl"),
            message: success.toString(),
            position: "tr",
            autoDismiss: 5,
            action: { label: "Dismiss" }
          })
        )
      }
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (year) fetchMakes()
  }, [year])

  useEffect(() => {
    if (make) fetchModels()
  }, [make])

  const formValid = year && make && model

  return (
    <div className="compare-vehicle-card">
      <div className="compare-vehicle-content">
        <Card fluid className="compare-vehicle-info">
          <Image src={InfoIcon} />
          <span>
            <b>{t("yourVehicleInfo")}</b> {t("askForYourVin")}
          </span>
        </Card>
        <label>
          {t("yearPlaceholder")} <span style={{ color: "red" }}>*</span>
        </label>
        <Dropdown
          fluid
          selection
          required
          placeholder={t("yearsPlaceholder")}
          options={years}
          value={year}
          onChange={(_, data) => onYearChange(data.value)}
          loading={false}
        />
        <label>
          {t("makePlaceholder")} <span style={{ color: "red" }}>*</span>
        </label>
        <Dropdown
          fluid
          selection
          required
          placeholder={t("makesPlaceholder")}
          options={makes}
          value={make}
          onChange={(_, data) => onMakeChange(data.value)}
          loading={loadingMakes}
        />
        <label>
          {t("modelPlaceholder")} <span style={{ color: "red" }}>*</span>
        </label>
        <Dropdown
          fluid
          selection
          required
          placeholder={t("modelsPlaceholder")}
          options={models}
          value={model}
          onChange={(_, data) => onModelChange(data.value)}
          loading={loadingModels}
        />
      </div>
      <Button
        fluid
        disabled={isLoading || !formValid}
        loading={isLoading}
        onClick={onClickNext}
        className="primary-button"
      >
        {isLoading ? <Loader active inline size="small" /> : t("saveContinue")}
      </Button>
    </div>
  )
}

function mapStateToProps(state, ownProps) {
  let user = state.user || {}
  return {
    user: user
  }
}

export default connect(mapStateToProps, { addNewVehicle })(
  withTranslation("vehicleDetails")(CompareVehicle)
)
